module.exports = __webpack_public_path__ + "img/powder-turbo2.8a815f7f.webp";